import type { FunctionComponent } from 'react';
import { Text } from '@mantine/core';

import { formatCurrency } from 'helpers/format.cuboh';
import type { PreviewModifier } from 'helpers/menuPreview';

type ModifierPriceProps = {
  modifier: PreviewModifier;
};

export const ModifierPrice: FunctionComponent<ModifierPriceProps> = ({ modifier }) => {
  if (!modifier.price) return null;

  return <Text c="var(--content-secondary)">{formatCurrency(modifier.price / 100)}</Text>;
};
